module.exports = __webpack_public_path__ + "static/img/tup1.d4902aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup1.png
// module id = tArz
// module chunks = 0